module.exports = __webpack_public_path__ + "img/confetti-cup.54a58d70.svg";